import React, { Component } from 'react';
import './Center.css';
import NavBar from './components/NavBar';
import DataTable from './components/DataTable';

const footerStyle = {
  backgroundColor: 'white',
  fontSize: '11px',
  color: 'white',
  textAlign: 'center',
  position: 'fixed',
  margingLeft: '10%',
  marginRight: '5%',
  bottom: '0',
  width: '100%',
  height: '3%',
};

const phantomStyle = {
  display: 'block',
  padding: '30%',
  height: '100%',
  position: 'fixed',
  width: '100%',
};

function LocalFooter({ children }) {
  return (
    <div>
      <div style={phantomStyle} />
      <div style={footerStyle}>{children}</div>
    </div>
  );
}

function Footer() {
  return (
    <span className="footer-text">
      Brought to you by{' '}
      <a
        className="link-style"
        href="https://zengo.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        ZenGo
      </a>
      . For more details, visit our{' '}
      <a
        className="link-style"
        href="https://zengo.com/farming-comp/"
        target="_blank"
        rel="noopener noreferrer"
      >
        blog
      </a>{' '}
    </span>
  );
}

class App extends Component {
  state = {
    address: ' ',
    results: [],
    total_earned: '',
    total_collected: '',
  };

  async componentDidMount() {
    //let results = '';

    let results = [
      ['BAT', '', '', ''],
      ['COMP', '', '', ''],
      ['DAI', '', '', ''],
      ['ETH', '', '', ''],
      ['REP', '', '', ''],
      ['UNI', '', '', ''],
      ['USDC', '', '', ''],
      ['USDT', '', '', ''],
      ['WBTC', '', '', ''],
      ['ZRX', '', '', ''],
    ];

    this.setState({
      results,
    });
  }

  fNumber(number) {
    if (Number(number) === 0) {
      return 0;
    }

    if (Number(number) < 0.0001) {
      return '>0.0001';
    } else {
      return Number(number).toFixed(4);
    }
  }

  async setResults(res) {
    let res_json;
    res_json = await res.json();

    let available_markets = [
      'BAT',
      'COMP',
      'DAI',
      'ETH',
      'REP',
      'UNI',
      'USDC',
      'USDT',
      'WBTC',
      'ZRX',
    ];
    let result_object = {
      BAT: {},
      COMP: {},
      DAI: {},
      ETH: {},
      REP: {},
      UNI: {},
      USDC: {},
      USDT: {},
      WBTC: {},
      ZRX: {},
    };
    for (let market of available_markets) {
      let obj = [market, 0, 0, 0];
      result_object[market] = obj;
    }

    let markets = res_json.markets;
    let total_earned = 0;
    let total_collected = 0;
    for (let market of markets) {
      let name = market.underlying_symbol;
      if (name in result_object) {
        let comp_allocated = market.comp_allocated;
        let comp_collected = market.comp_distributed;
        let daily = market.daily_comp;
        let comp_earned = Number(comp_allocated) - Number(comp_collected);
        result_object[name] = [
          name,
          this.fNumber(comp_collected),
          this.fNumber(comp_earned),
          this.fNumber(daily),
        ];
        total_earned += Number(comp_earned);
        total_collected += Number(comp_collected);
      }
    }
    // result_object['Total'] = [
    //   'Total',
    //   this.fNumber(total_collected),
    //   this.fNumber(total_earned),
    // ];
    let results_list = [];
    for (let market of available_markets) {
      results_list.push(result_object[market]);
    }

    let results = results_list;
    this.setState({
      results,
      total_collected: this.fNumber(total_collected),
      total_earned: this.fNumber(total_earned),
    });
  }

  onSubmit = async (event) => {
    let address = this.state.address;
    let call = `https://api.compound.finance/api/v2/governance/comp/account?address=${address}&network=mainnet`;
    let res = await fetch(call);
    this.setResults(res);
  };

  getBalanceButton = () => {
    return (
      <div className="col-md-4">
        <button
          type="button"
          className="primary-btn btn-block"
          onClick={this.onSubmit}
        >
          Find Balance
        </button>
      </div>
    );
  };

  render() {
    const headings = ['Market', 'Collected', 'Accrued', 'COMP/Day'];

    return (
      <div>
        <NavBar stepName="One" />
        <div className="header">
          <img
            src={process.env.PUBLIC_URL + '/images/Compound3x.png'}
            height="70"
          />
          <h1>Easily find your COMP balance</h1>
        </div>
        <div class="row">
          <div className="content">
            <form className="form">
              <div htmlFor="fname" style={{ padding: '8px' }}>
                Your ETH Address
              </div>
              <input
                type="string"
                className="swapInput"
                onChange={(event) =>
                  this.setState({ address: event.target.value })
                }
              />
              <div style={{ marginLeft: '8px' }}>{this.getBalanceButton()}</div>
              <br />
            </form>
            <div className="results">
              <div className="something">
                <h3>Totals</h3>
                <span>
                  <b>Total accrued balance: </b> {this.state.total_earned}
                </span>
                <span>
                  <b>Total collected balance: </b> {this.state.total_collected}
                </span>
                <br />
                <h3>Breakdown</h3>
              </div>
              <DataTable headings={headings} rows={this.state.results} />
            </div>
          </div>
        </div>
        <br />
        <br />
        <LocalFooter>
          <Footer />
        </LocalFooter>
      </div>
    );
  }
}
export default App;
